/**
 * Configuration constants for Autohero Cross-Promo Banner
 * Used in CarleadCrossPromoBannerAH component
 */

/**
 * MIDs for tracking Autohero cross-promo clicks
 */
export const CROSS_PROMO_MIDS = {
  'de-DE': 'DE_CMX_16-103_11_1_1-0-31-30_0_0',
  'es-ES': 'ES_CMX_16-105_11_1_1-0-31-30_0_0',
  'fr-FR': 'FR_CMX_16-113_11_1_1-0-31-30_0_0',
  'it-IT': 'IT_CMX_16-104_11_1_1-0-31-30_0_0',
  'nl-NL': 'NL_CMX_16-115_11_1_1-0-31-30_0_0',
  'de-AT': 'AT_CMX_16-106_11_1_1-0-31-30_0_0',
  'nl-BE': 'B1_CMX_16-116_11_1_1-0-31-30_0_0',
  'fr-BE': 'B2_CMX_16-117_11_1_1-0-31-30_0_0',
  'sv-SE': 'SE_CMX_16-114_11_1_1-0-31-30_0_0'
};

/**
 * WKDA logo URLs by locale
 * These are locale-specific white/orange logos hosted on content CDN
 */
export const WKDA_LOGO_URLS = {
  'de-DE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-de.svg',
  'es-ES': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-es.svg',
  'fr-FR': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-fr.svg',
  'it-IT': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-it.svg',
  'nl-NL': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-nl.svg',
  'de-AT': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-at.svg',
  'nl-BE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-nl_be.svg',
  'fr-BE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-fr_be.svg',
  'sv-SE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-logo-white-orange-cross-promo-se.svg'
};

/**
 * Autohero domain mapping by locale
 * Used to construct redirect URLs
 */
export const AUTOHERO_DOMAINS = {
  'de-DE': 'de',
  'es-ES': 'es',
  'fr-FR': 'fr',
  'it-IT': 'it',
  'nl-NL': 'nl',
  'de-AT': 'at',
  'nl-BE': 'nl-be',
  'fr-BE': 'fr-be',
  'sv-SE': 'se'
};
const WKDA_X_AH_LOGO_URLS = {
  'de-DE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-de.svg',
  'es-ES': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-es.svg',
  'fr-FR': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-fr.svg',
  'it-IT': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-it.svg',
  'nl-NL': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-nl.svg',
  'de-AT': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-de_at.svg',
  'nl-BE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-nl_be.svg',
  'fr-BE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-fr_be.svg',
  'sv-SE': 'https://content.wirkaufendeinauto.de/static/car_images/wkda-x-ah-badge-white-orange-sv_se.svg'
};
/**
 * Construct Autohero CTA URL with MID
 * @param {string} locale - Locale code (e.g., 'es-ES')
 * @returns {string} Full Autohero URL with MID parameter
 */
export const getAutoheroUrl = locale => {
  const pathname = AUTOHERO_DOMAINS[locale] || 'de';
  const mid = CROSS_PROMO_MIDS[locale] || CROSS_PROMO_MIDS['de-DE'];
  return `https://www.autohero.com/${pathname}/search/?MID=${mid}`;
};

/**
 * Get WKDA logo URL for locale
 * @param {string} locale - Locale code (e.g., 'es-ES')
 * @returns {string} WKDA logo URL
 */
export const getWkdaLogoUrl = locale => {
  return WKDA_LOGO_URLS[locale] || WKDA_LOGO_URLS['de-DE'];
};
export const getWkdaXAhLogoUrl = locale => {
  return WKDA_X_AH_LOGO_URLS[locale] || WKDA_X_AH_LOGO_URLS['de-DE'];
};